export const IMPORT_TYPE = {
  BULK_ORDER_CREATION: "bulk-order-creation",
  BULK_ASSIGN_BADGES: "bulk-assign-badges",
} as const;

export type ImportType = (typeof IMPORT_TYPE)[keyof typeof IMPORT_TYPE];

export type ImportOptionType = {
  id: number;
  value: ImportType;
  label: string;
};

export const BULK_ORDER_CREATION_OPTION: ImportOptionType = {
  id: 1,
  value: IMPORT_TYPE.BULK_ORDER_CREATION,
  label: "Bulk Order Creation",
};

export const BULK_ASSIGN_BADGES_OPTION: ImportOptionType = {
  id: 2,
  value: IMPORT_TYPE.BULK_ASSIGN_BADGES,
  label: "Bulk Assign Badges",
};
